import { render, staticRenderFns } from "./ModernPieChart.vue?vue&type=template&id=414b39c0&scoped=true&"
import script from "./ModernPieChart.vue?vue&type=script&lang=js&"
export * from "./ModernPieChart.vue?vue&type=script&lang=js&"
import style0 from "./ModernPieChart.vue?vue&type=style&index=0&id=414b39c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414b39c0",
  null
  
)

export default component.exports